import React from 'react'
import { Link, Route, Routes, useLocation } from 'react-router-dom'
import Layout from '../components/Layout'
import { BuildingStorefrontIcon, MapPinIcon } from '@heroicons/react/24/outline'
import RvmPlanningPage from './RvmPlanningPage'

const retailerNavigationItems = [
  { name: 'Retailer Dashboard', href: '/retailers/dashboard', icon: BuildingStorefrontIcon },
  { name: 'RVM Planning (Read-only)', href: '/retailers/planning', icon: MapPinIcon }
]

const RetailerNavigation: React.FC = () => {
  const location = useLocation()

  return (
    <div className="border-b border-gray-200 mb-8">
      <nav className="flex flex-wrap gap-4 sm:gap-8">
        {retailerNavigationItems.map((item) => {
          const isActive =
            location.pathname === item.href ||
            (item.href === '/retailers/dashboard' && location.pathname === '/retailers')

          return (
            <Link
              key={item.name}
              to={item.href}
              className={`flex items-center py-2 px-1 border-b-2 font-medium text-sm transition-colors ${
                isActive
                  ? 'border-primary-500 text-primary-600'
                  : 'border-transparent text-gray-500 hover:text-primary-600 hover:border-primary-200'
              }`}
            >
              <item.icon className="h-5 w-5 mr-2" />
              {item.name}
            </Link>
          )
        })}
      </nav>
    </div>
  )
}

const RetailersDashboard: React.FC = () => {
  return (
    <div className="py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <RetailerNavigation />
        <h1 className="text-2xl font-bold text-gray-900 mb-8">Retailers Portal</h1>
        <div className="bg-white rounded-lg shadow p-8 text-center">
          <BuildingStorefrontIcon className="h-12 w-12 text-orange-600 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">Retailer Dashboard</h3>
          <p className="text-gray-600">Access retailer-level reports and planning insights in read-only mode.</p>
          <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="bg-orange-50 p-4 rounded-lg">
              <h4 className="font-medium text-orange-900">Retailer Dashboard</h4>
              <p className="text-sm text-orange-700 mt-1">Track your retail recycling metrics</p>
            </div>
            <div className="bg-orange-50 p-4 rounded-lg">
              <h4 className="font-medium text-orange-900">Planning Review</h4>
              <p className="text-sm text-orange-700 mt-1">Review proposed RVM expansion priorities</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const RetailersPortal: React.FC = () => {
  return (
    <Layout portalType="retailers">
      <Routes>
        <Route path="/" element={<RetailersDashboard />} />
        <Route path="/dashboard" element={<RetailersDashboard />} />
        <Route path="/planning" element={<RvmPlanningPage readonlyView homeRoute="/retailers/dashboard" title="RVM Planning Intelligence (Read-only)" />} />
      </Routes>
    </Layout>
  )
}

export default RetailersPortal
